export default __webpack_public_path__ + "static/media/no77SharkOpen.ffa495ce.jpg";